/* hs-eslint ignored failing-rules */
/* eslint-disable react/no-unused-prop-types */

import { Component } from 'react';
import I18n from 'I18n';
import TimezoneTypes from '../constants/TimezoneTypes';
// @ts-expect-error untyped JS module
import formatDuration from '../utils/formatRelativeDuration';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error untyped
const getRelativeDuration = (from, to, options) => formatDuration(I18n.moment.duration(Math.abs(to.diff(from))), options);
export default class FormattedDuration extends Component {
  render() {
    const {
      includeAffix,
      type,
      from,
      to,
      format,
      combined
    } = this.props;

    // @ts-expect-error Type 'undefined' cannot be used as an index type.
    const nowMoment = I18n.moment[type]();
    let duration;
    if (!to && !from) {
      duration = '';
    } else if (!to) {
      // @ts-expect-error from/to types are wider than MomentInput
      const fromValue = I18n.moment[type](from);
      duration = format ? getRelativeDuration(fromValue, nowMoment, {
        format,
        combined
      }) : fromValue.toNow(!includeAffix);
    } else if (!from) {
      // @ts-expect-error Type 'undefined' cannot be used as an index type.
      const toValue = I18n.moment[type](to);
      duration = format ? getRelativeDuration(nowMoment, toValue, {
        format,
        combined
      }) : toValue.fromNow(!includeAffix);
    } else {
      // @ts-expect-error Type 'undefined' cannot be used as an index type.
      const fromValue = I18n.moment[type](from);
      // @ts-expect-error Type 'undefined' cannot be used as an index type.
      const toValue = I18n.moment[type](to);
      duration = format ? getRelativeDuration(fromValue, toValue, {
        format,
        combined
      }) : toValue.from(fromValue, !includeAffix);
    }
    return /*#__PURE__*/_jsx("span", {
      children: duration
    });
  }
}
FormattedDuration.displayName = 'FormattedDuration';
FormattedDuration.contextType = I18nHMRContext;
FormattedDuration.defaultProps = {
  type: TimezoneTypes.PORTAL,
  includeAffix: false,
  combined: false
};